import { RouteGuard } from '@/router/routeGuard';
import { RouteConfig } from 'vue-router';


const routes: Array<RouteConfig> = [
    {
      path: "/contabil/contas-receber",
      name: "ContasReceber",
      component: () => import("@/views/private/contabil/contas-receber/RelatorioContaReceber.vue"),
      beforeEnter: RouteGuard.acessoContabil
    },
    {
      path: "/contabil/contas-pagar",
      name: "ContasPagar",
      component: () => import("@/views/private/contabil/contas-pagar/RelatorioContaPagar.vue"),
      beforeEnter: RouteGuard.acessoContabil
    },
    {
      path: "/contabil/faturamento-bruto",
      name: "FaturamentoBruto",
      component: () => import("@/views/private/contabil/faturamento-bruto/RelatorioFaturamentoBruto.vue"),
      beforeEnter: RouteGuard.acessoContabil
    },
    {
      path: "/contabil/orcamento-frota",
      name: "OrcamentoFrota",
      component: () => import("@/views/private/contabil/orcamento-frota/RelatorioOrcamentoFrota.vue"),
      beforeEnter: RouteGuard.acessoContabil
    },
    {
      path: "/contabil/produto-frota/faturamento/validacao-pagamento",
      name: "FaturamentoValidacaoPagamento",
      component: () => import("@/views/private/contabil/produto-frota/ValidacaoPagamento.vue"),
      beforeEnter: RouteGuard.acessoContabil
    },
    {
      path: "/contabil/validacao-contabil",
      name: "ValidacaoContabil",
      component: () => import("@/views/private/contabil/ValidacaoContabil.vue"),
      beforeEnter: RouteGuard.acessoContabil
    },
    {
      path: "/contabil/validacao-transferencia",
      name: "ValidacaoTransferencia",
      component: () => import("@/views/private/contabil/ValidacaoTransferencia.vue"),
      beforeEnter: RouteGuard.acessoContabil
    },
    {
      path: "/contabil/ordem-pagamento-prestador",
      name: "OrdemPagamentoPrestador",
      component: () => import("@/views/private/contabil/OrdemPagamentoPrestador.vue"),
      beforeEnter: RouteGuard.acessoContabil
    },
    {
      path: "/contabil/data-cempro",
      name: "RelatorioDataCempro",
      component: () => import("@/views/private/contabil/data-cempro/RelatorioDataCempro.vue"),
      beforeEnter: RouteGuard.acessoContabil
    },
    {
      path: "/contabil/receita",
      name: "RelatorioReceita",
      component: () => import("@/views/private/contabil/receita/RelatorioReceita.vue"),
      beforeEnter: RouteGuard.acessoContabil
    },
    
    
]

export default routes;